import { ReactNode } from 'react';
import { IMyLensesFittedCardsListProps } from './my-lenses-fitted-cards-list.models';
import {
  IConsumerLensesParams,
  ProductType,
} from '../../../../../graphql/lenses/models/get-lenses.models';
import { useStyles } from './my-lenses-fitted-cards-list.styles';
import { Card } from '../../../../common/card';
import { LensesCard } from './lenses-card';
import { SolutionsCard } from './solutions-card';
import { useDependentColors } from '../../../../../hooks/use-dependent-colors';

export const MyLensesFittedCardsList = ({ cards }: IMyLensesFittedCardsListProps): JSX.Element => {
  const classes = useStyles();
  const { getDependentColorIndex } = useDependentColors();

  const hasKidProfiles = cards.some((card) => card.dependent);

  return (
    <Card className={classes.root}>
      <ul className={classes.cardsList}>
        {cards.map((card: IConsumerLensesParams, index) => {
          let fittedCard: ReactNode;
          const dependent = card.dependent;
          const profileColorIndex = dependent?.firstName && dependent?.lastName
            ? getDependentColorIndex(dependent.firstName, dependent.lastName)
            : undefined;

          if (card.brand) {
            switch (card.brand.productType) {
              case ProductType.lenses:
                fittedCard = (
                  <LensesCard
                    key={`${card.brandId}-${dependent?.firstName}-${dependent?.lastName}-${index}`}
                    cardData={card}
                    profileFirstName={
                      dependent?.firstName || (hasKidProfiles ? 'Consumer' : undefined)
                    }
                    profileLastName={dependent?.lastName}
                    profileIsActive={dependent?.active ?? true}
                    profileColorIndex={profileColorIndex}
                    hasKidProfiles={hasKidProfiles}
                  />
                );
                break;
              case ProductType.solutions:
                fittedCard = (
                  <SolutionsCard
                    key={`${card.brandId}-${dependent?.firstName}-${dependent?.lastName}-${index}`}
                    cardData={card}
                  />
                );
                break;
              default:
                fittedCard = null;
                break;
            }
          }
          return fittedCard;
        })}
      </ul>
    </Card>
  );
};
